"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { confirmChunkLoadRecovery } from "@/lib/chunk-load-recovery";

const RECOVERY_STABILITY_WINDOW_MS = 5_000;

export function ChunkLoadRecoveryReporter() {
  useEffect(() => {
    let timeout: number | undefined;
    const confirmAfterStabilityWindow = () => {
      timeout = window.setTimeout(() => {
        const confirmation = confirmChunkLoadRecovery(
          window.location.pathname,
        );
        if (confirmation) {
          posthog.capture("chunk_load_recovery_succeeded", {
            pathname: confirmation.attemptedPathname,
            rendered_pathname: confirmation.renderedPathname,
          });
        }
      }, RECOVERY_STABILITY_WINDOW_MS);
    };

    if (document.readyState === "complete") {
      confirmAfterStabilityWindow();
    } else {
      window.addEventListener("load", confirmAfterStabilityWindow, {
        once: true,
      });
    }

    return () => {
      window.removeEventListener("load", confirmAfterStabilityWindow);
      if (timeout !== undefined) window.clearTimeout(timeout);
    };
  }, []);

  return null;
}
